import http from 'plugins/axios';

export default {
  getGasList({page,size,coin}){
    return http.get({
      url:`/la/admin/gas/list?page=${page}&size=${size}&coin=${coin}`
    })
  },
  updateGasDto(data){
    return http.post({
      url:'/la/admin/gas/update',
      data
    })
  },
  getBlockInfoList({page,size, isFinished,disposeStatusInner}){
    return http.get({
      url:`/la/admin/block/info/list?page=${page}&size=${size}&isFinished=${isFinished}&disposeStatusInner=${disposeStatusInner}`
    })
  },
  delOne(id){
    return http.post({
      url:`/la/admin/block/info/del?id=${id}`
    })
  },
  updatInfo(blockInfoDto){
    return http.post({
      url:`/la/admin/block/info/update`,
      data:{...blockInfoDto}
    })
  }
};
